import { useState } from "react";
import axios from "axios";

export default function AdminLogin({ onAuthenticated }) {
  const [error, setError] = useState("");
  const [remember, setRemember] = useState(false);

  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const username = e.target.username.value;
    const password = e.target.password.value;

    try {
      const res = await axios.post(
        `${API_BASE}login`,
        {
          username,
          password,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = res.data;

      if (remember) localStorage.setItem("token", data.access_token);
      onAuthenticated(data.access_token);
    } catch (err) {
      setError(
        err.response?.data?.detail || err.message || "Something went wrong"
      );
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded shadow-md w-full max-w-sm"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">Admin Login</h2>
        {error && <p className="text-red-600 mb-2">{error}</p>}
        <input
          name="username"
          className="w-full mb-3 p-2 border rounded"
          placeholder="Username"
          required
        />
        <input
          name="password"
          type="password"
          className="w-full mb-3 p-2 border rounded"
          placeholder="Password"
          required
        />
        <label className="flex items-center mb-3">
          <input
            type="checkbox"
            onChange={() => setRemember(!remember)}
            className="mr-2"
          />
          Remember me
        </label>
        <button className="bg-blue-600 text-white px-4 py-2 rounded w-full">
          Login
        </button>
      </form>
    </div>
  );
}
